<template>
  <div>
    <v-dialog v-model="exibir" scrollable persistent :max-width="maxWidth">
      <v-card>
        <v-card-title class="primary modal-title py-0">
          <span>Confirmação
          </span>
          <v-spacer/>
          <v-btn icon @click="fecharModal">
            <v-icon size="20" color="white">close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-layout row wrap>
            <v-flex>
              <div id="recaptcha" data-size="normal"
                   :data-sitekey="reCaptchaSiteKey"></div>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-layout class="justify-space-between">
            <v-btn class="ml-2 mb-2" @click="fecharModal">CANCELAR</v-btn>
            <v-btn class="mr-2 mb-2 primary" @click="baixarArquivo(item)">
              BAIXAR
            </v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import {mapState} from 'vuex'
import {actionTypes} from '@/core/constants'

export default {
    name: 'ModalConfirmarCaptchaDownload',
    props: {
        exibir:{
            type: Boolean,
            default: false
        },
        maxWidth: {
            type: String,
            default: '800'
        },
        item:{
            type: Object
        },
        licitacaoId:{
            type: Number
        }
    },
    mounted() {
        this.renderizarRecaptcha()
    },
    computed: {
        ...mapState(['loki', 'licitacao', 'parametros']),
        reCaptchaSiteKey(){
            return this.parametros.reCaptchaSiteKey
        }
    },
    methods: {
        async baixarArquivo(doc) {
            const captchaResponse = grecaptcha.getResponse()
            if(captchaResponse === '') {
                const mensagem = 'Selecione o Captcha para prosseguir'
                this.mostrarNotificacaoErro(mensagem)
            } else {
                const payload = {
                    licitacaoId: this.licitacaoId,
                    documentoVirtualizadoId: doc.idVirtualizado,
                    nomeArquivo: doc.arquivoNome,
                    externo: doc.externo,
                    uri: doc.arquivoUri,
                    areaPublica: true
                }
                const headers = {
                    'az-licitacao-captcha': captchaResponse
                }
                await this.$store.dispatch(actionTypes.FLOWBEE.BAIXAR_ARQUIVO, { payload, headers })
                this.mostrarNotificacaoSucessoDefault()
                grecaptcha.reset()
                this.fecharModal()
            }
        },
        fecharModal() {
            grecaptcha.reset()
            this.$emit('fecharModal')
        },
        renderizarRecaptcha(i=0){
            try {
                grecaptcha.render('recaptcha')
            }catch(e){
                if(i>=4) return
                setTimeout(() => {
                    this.renderizarRecaptcha(i+1)
                }, 1000)
            }
        }
    }
}
</script>

<style lang="stylus">
.modal-title
  margin: 0
  padding: 10px 20px
  font-size: 18px !important
  color: white
</style>
